import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["selectVariantOptionText", "budgetBasePrice"]

  connect() {
    this.productID = this.element.dataset.product
    this.priceCounter = document.getElementById(`product_${this.productID}_price`)
    this.priceCounterText = this.priceCounter.querySelector(".price-counter-text")

    this.originalPriceCounterText = this.priceCounterText.innerText
    
    this.calendarBasePrice = document.getElementById("advent_calendar_budget_base_price")

    this.calendarBasePrice.innerText = this.priceCounterText.innerText;
    
  }

  selectVariant(e) {
    var select = e.target
    var selectedVariant = select.options[select.selectedIndex]
    var selectedVariantPrice = selectedVariant.dataset.price
    var selectedVariantPriceFormatted = selectedVariant.dataset.priceFormatted
    console.log(selectedVariantPriceFormatted)
    this.priceCounterText.innerText = selectedVariantPriceFormatted == undefined ? this.originalPriceCounterText : selectedVariantPriceFormatted



    // Show variant extra options
    document.querySelectorAll(`select[name=product_variant_option]`).forEach(select => {
      select.classList.add("hidden") 
      this.selectVariantOptionTextTarget.classList.add("hidden")
    });

    var variantOptionsSelect = document.querySelector(`select[name='product_variant_option'][data-parent-variant='${selectedVariant.value}']`)

    if (!!variantOptionsSelect) {
      variantOptionsSelect.classList.remove("hidden")
      this.selectVariantOptionTextTarget.classList.remove("hidden") 

      }

    
    this.calendarBasePrice.innerText = this.priceCounterText.innerText;

    

  }

  selectVariantOption(e) {
    var select = e.target
    var selectedVariantOption = select.options[select.selectedIndex]
    var selectedVariantOptionPrice = selectedVariantOption.dataset.price
    var selectedVariantOptionPriceFormatted = selectedVariantOption.dataset.priceFormatted
    console.log(selectedVariantOptionPriceFormatted)
    this.priceCounterText.innerText = selectedVariantOptionPriceFormatted == undefined ? this.originalPriceCounterText : selectedVariantOptionPriceFormatted
    this.calendarBasePrice.innerText = this.priceCounterText.innerText;
  }


}
